<template>
  <div class="buy">
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">购买</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 购买服务顶部 开始 -->
    <div class="buy_top">
      <img class="buy_img" :src="showItem.product.thumb" />
      <div class="buy_name">{{ showItem.name }}</div>
    </div>
    <!-- 购买服务顶部 结束 -->
    <!-- 商品信息 开始 -->
    <div class="buy_shangpinmesg">
      <div class="buy_shangpin_title">
        <img class="buy_shangpin_title_icon" src="/static/newprojecticon/title.png" />
        <div class="buy_shangpin_title_name">商品信息</div>
      </div>
      <!-- <div class="buy_shangpin_box">
        <div class="buy_shangpin_mesgname">商品原价</div>
        <div class="buy_shangpin_shoujia">{{ showItem.m_price }}元</div>
      </div> -->
      <!-- <div class="buy_shangpin_box">
        <div class="buy_shangpin_mesgname">商品优惠</div>
        <div class="buy_shangpin_shoujia">{{ discount }}</div>
      </div> -->
      <div class="buy_shangpin_box">
        <div class="buy_shangpin_mesgname">商品优惠</div>
        <div class="buy_shangpin_shoujia">{{ preferentialAmount > 0 ? preferentialAmount+'元' : '无' }}</div>
      </div>
      <div class="buy_shangpin_box">
        <div class="buy_shangpin_mesgname">应付金额</div>
        <!-- {{ showItem.price }}元 -->
        <div class="buy_shangpin_shoujia">{{payAmount}}元</div>
      </div>
      <div class="buy_shangpin_box" v-if="phoneNum">
        <div class="buy_shangpin_mesgname">赠送好友</div>
        <div class="buy_shangpin_shoujia">{{ phoneNum }}</div>
      </div>
    </div>
    <!-- 商品信息 结束 -->
    <!-- 支付方式 开始 -->
    <div class="buy_shangpinmesg1">
      <div class="buy_shangpin_title">
        <img class="buy_shangpin_title_icon" src="/static/newprojecticon/title.png" />
        <div class="buy_shangpin_title_name">支付方式</div>
      </div>
      <!--      <div class="buy_shangpin_box" @click="weixinPay()">
        <div class="buy_shangpin_mesgname1">
          <img src="/static/weixinpay.png" class="buy_shangpin_mesglogo" />
          <div class="buy_shangpin_mesgname">微信支付</div>
        </div>
        <div class="buy_shangpin_usejifen">
          <div class="buy_shangpin_shoujia">{{ showItem.price }}元</div>
          <img :src="isWeixinPay? '/static/newprojecticon/checkedicon.png' : '/static/newprojecticon/checkicon.png'" class="checklogo" />
        </div>

      </div> -->
      <div class="buy_shangpin_box" @click="yuePay()">
        <div class="buy_shangpin_mesgname1">
          <img src="/static/jifenpay.png" class="buy_shangpin_mesglogo" />
          <div class="buy_shangpin_mesgname">积分支付</div>
        </div>
        <div class="buy_shangpin_usejifen">
          <div class="buy_shangpin_keyong">可用积分</div>
          <div class="buy_shangpin_shoujia">{{amount}}</div>
          <!-- <img src="/static/newprojecticon/nocheck.png" class="checklogo" /> -->
          <img :src="isWeixinPay? '/static/newprojecticon/checkicon.png' : '/static/newprojecticon/checkedicon.png'"
            class="checklogo" />
        </div>
      </div>
      <div class="reserceDesc_fuwuprice" @click="(settlementItem.couponList && settlementItem.couponList.length) ? showPopup() : '' ">
        <!-- <div class="reserceDesc_fuwupricename">服务券</div> -->
        <div class="buy_shangpin_mesgname1">
          <img src="/static/kaquanpay.png" class="buy_shangpin_mesglogo" />
          <div class="buy_shangpin_mesgname">服务立减券</div>
        </div>
        <div class="reserceDesc_jiesuancheck">
          <div class="reserceDesc_jiesuanpricenum">{{settlementItem.couponList ? settlementItem.couponList.length : 0}}
            张</div>
          <div class="reserceDesc_jiesuanpricenum" v-if="settlementItem.selectedID">已选</div>
          <div class="reserceDesc_jiesuanpricenum" v-else>未选</div>
          <img class="reserceDesc_check" :src="!!settlementItem.selectedID ? '/static/checkdeicon.png' : '/static/checkicon.png'" />
          <!-- <input type="radio" name="pay_type" disabled :checked="!!settlementItem.selectedID" /> -->
        </div>
      </div>
    </div>
    <!-- 支付方式 结束 -->
    <!-- 支付 开始 -->
    <div class="page_button buy_button" @click="zhifu()">
      <div class="page_zhifu">确认支付</div>
    </div>
    <!-- 支付 结束 -->
    <van-popup v-model="show" round closeable close-icon="close" position="bottom" :style="{ 'min-height': '40%' }">
      <div class="popup_top">
        <div>可使用券</div>
      </div>
      <div :class="item.checked? 'couponBox-select' : 'couponBox' " @click="couponChange(index)" v-for="(item,index) in settlementItem.couponList">
        <!-- v-if="item.product.id == showItem.product_id && item.status == 0" -->
        <div>
          <img class="canUseimg" src="/static/keyong.png" />
          <div class="coupon-name">{{ item.name ? item.name : item.product.name }}</div>
          <div class="coupon-time">到期日期：{{ item.overdue_at }}</div>
        </div>
      </div>
    </van-popup>
    <!-- <van-popup v-model="show" position="bottom" :style="{ 'max-height': '70%' }">
      <div class="popup_top" @click="guanbi()">
        <img class="guanbi" src="/static/guanbi.png" />
        <div>可使用券</div>
      </div>
      <div class="couponCont maskCont">
        <div class="reserceDesc_section">
          <div class="scroll-div">
            <div v-for="(item,index) in settlementItem.couponList" :key="index" class="couponCell" hover-class="weui-cell_active"
              v-if="item.product.id == showItem.product_id && item.status == 0">
              <div class="cellLeft" @click="couponChange(index)">
                <div>{{ item.product.id == showItem.product_id ? '可用':'不可用' }}</div>
                <div class="cont">{{ item.product ? item.product.name : '' }}</div>
                <div>编号: {{ item.card_no }}</div>
                <div>到期: {{ item.overdue_at }}</div>
              </div>
              <input type="radio" @click="couponChange(index)" id="couponChange" name="coupon" :data-index="index"
                :disabled="item.product.id != showItem.product_id" :checked=" item.checked " />
            </div>
          </div>
        </div>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        userInfo: {},
        mobile: "",
        showItem: {}, //上个页面传来的值
        amount: '0.00', // 可用余额
        settlementItem: {
          canAmountPay: false, // 前端计算可用余额是否大于服务价格,默认为false
          couponList: [], // 服务券列表,默认为空
          isAmountPay: false, // 用户是否使用余额结算,默认为false
          selectedID: "" // 用户选择服务券的编号,默认为空
        }, // 接口获取结算方式
        maskStatus: '', // 遮盖层所展示的状态类型
        isMaskHidden: true, // 是否隐藏遮盖层,默认为true
        buttonClicked: false, // 防止支付重复点击,默认为false
        order_param: {},
        phoneNum: "", //手机号
        isWeixinPay: false, //微信支付
        show: false, //是否显示服务券列表弹出框
        preferentialAmount: 0, //满减券优惠金额
        payAmount: 0, //应付金额
      }
    },
    created() {

      // if (!this.$route.query.name) return
      this.showItem = this.$route.query.showItem
      console.log("showItem", this.$route.query.showItem)
      let originalPrice = parseFloat(this.showItem.m_price)
      let price = parseFloat(this.showItem.price)
      if (this.$route.query.phoneNum) {
        this.phoneNum = this.$route.query.phoneNum
      }
      this.discount = originalPrice > price ? '-' + (originalPrice - price).toFixed(2) + '元' : '无'
      this.request('getUserInfo')
      //获取卡券列表
      this.request("getCouponList");
    },
    mounted() {
      // if (!this.id) return;
      // let requestData = {
      //   id: this.id
      // };
      // this.request("getPackageDetail", requestData);
    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true;
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === "number") {
            setTimeout(() => {
              this.buttonClicked = false;
            }, duration);
          }
          resolve(true);
        });
      },
      // showMask(status = true, length = 300) {
      //   this.buttonClicked.call(this, 500).then(() => {
      //     switch (status) {
      //       case true:
      //         fadeIn.call(this)
      //         setTimeout(() => {
      //           this.isMaskHidden = false

      //           fadeUp.call(this, Number(0 - length), 1)
      //         }, 800)
      //         break
      //       case false:
      //         fadeIn.call(this, 0)
      //         fadeUp.call(this, length, 0)
      //         setTimeout(() => {
      //           this.isMaskHidden = true

      //         }, 800)
      //     }
      //   })
      // },
      // 展示/隐藏遮盖层
      // mask(mask_status) {
      //   this.maskStatus = mask_status
      //   this.isMaskHidden ? this.showMask.call(this) : this.showMask.call(this, false)
      // },
      // 选择余额结算
      // amountPayChange() {
      //   let settlementItem = this.settlementItem
      //   let couponList = settlementItem.couponList

      //   if (!settlementItem.canAmountPay) return
      //   if (!settlementItem.isAmountPay) couponList.map(item => item.checked = false)
      //   this.settlementItem = {
      //     amount: settlementItem.amount,
      //     canAmountPay: settlementItem.canAmountPay,
      //     couponList: couponList,
      //     isAmountPay: !settlementItem.isAmountPay,
      //     selectedID: settlementItem.isAmountPay ? settlementItem.selectedID : ''
      //   }
      // },
      //关闭弹出层
      guanbi() {
        this.show = false
      },
      showPopup() {
        this.show = true
      },
      // 选择服务券
      couponChange(sel_index) {
        let that = this
        let settlementItem = that.settlementItem;
        let couponList = settlementItem.couponList;
        console.log("couponList", couponList)
        // for(let i=0 ;i<couponList.length;i++){
        //   if(i == Number(sel_index)){
        //     if(){

        //     }

        //   }
        // }
        couponList.map(function(item, i) {
          if (i == Number(sel_index)) {
            if (item.checked == false) {
              item.checked = true
              that.settlementItem.selectedID = item.id;
              //满减券优惠金额
              that.preferentialAmount = item.amount
              //卡券金额
              let originalPrice = parseFloat(that.preferentialAmount)
              //商品价格
              let price = parseFloat(that.showItem.price)
              //实付金额
              that.payAmount = price > originalPrice ? (price - originalPrice).toFixed(2) : 0
            } else {
              item.checked = false;
              that.settlementItem.selectedID = ''
              //满减券优惠金额
              that.preferentialAmount = 0
              //实付金额
              that.payAmount = parseFloat(that.showItem.price)
            }
          } else {
            item.checked = false;
          }
        })
        that.settlementItem = settlementItem;
        console.log("settlementItem", settlementItem)
        //that.settlementItem.isAmountPay = false;
        //that.isWeixinPay = false
        that.guanbi();
      },
      // 选择服务券
      // couponChange(index) {
      //   let settlementItem = this.settlementItem
      //   let couponList = settlementItem.couponList
      //   couponList[Number(index)].checked ? couponList[Number(index)].checked = false : couponList.map((item, index) =>
      //     item.checked = index === Number(index))
      //   this.settlementItem = settlementItem
      //   this.settlementItem.couponList = couponList
      //   that.setData(data)
      // },

      // 点击确定选择服务券
      // selectCoupon() {
      //   let settlementItem = this.settlementItem
      //   let couponList = settlementItem.couponList
      //   this.settlementItem = settlementItem
      //   this.settlementItem.selectedID = ''
      //   this.settlementItem.couponList.forEach(item => {
      //     if (item.checked) {
      //       this.settlementItem.selectedID = item.id
      //       this.settlementItem.isAmountPay = false
      //     }
      //   })
      //   this.buttonClicked = false
      //   this.showMask.call(this, false)
      // },
      // pay(){

      // },
      //微信支付
      // weixinPay() {
      //   this.isWeixinPay = true
      // },
      //余额支付
      yuePay() {
        this.isWeixinPay = false
      },
      zhifu() {
        let that = this
        this.buttonClickedFun(1000) // 防止重复点击
        if ((!this.mobile)) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        }
        // if (this.serviceItem.price <= this.settlementItem.amount) {
        //   this.settlementItem.canAmountPay = true
        //   this.settlementItem.isAmountPay = true
        // }
        console.log("showItem", this.showItem)
        var order_param = this.order_param
        //order_param.amount = this.payAmount
        order_param.amount = this.showItem.price
        order_param.type = 'offline'
        order_param.product_type = 1
        order_param.product_item_id = this.showItem.id
        if (that.settlementItem.selectedID) {
          order_param.coupon_id = that.settlementItem.selectedID
        }

        if (this.phoneNum) {
          order_param.recharge_number = this.phoneNum
        }
        // 判断用户是微信支付还是余额支付
        // console.log()
        // if (that.isWeixinPay) {
        //   Dialog.confirm({
        //       title: '提示',
        //       message: '是否用微信支付?',
        //     })
        //     .then(() => {
        //       order_param.pay_type = 'wechatpay'
        //       that.request('WxunifiedOrder', order_param)
        //     })
        //     .catch(() => {
        //       return false;
        //     });
        // } else {
          if(that.settlementItem.selectedID){
            if (parseFloat(that.amount) < parseFloat(this.payAmount)) {
              Dialog.confirm({
                  title: '提示',
                  message: '积分不足，前往充值？',
                })
                .then(() => {
                  that.$router.push({
                    path: "/account"
                  })
                })
                .catch(() => {
                  return false;
                });
            } else {
              Dialog.confirm({
                  title: '提示',
                  message: '是否用余额支付?',
                })
                .then(() => {
                  order_param.pay_type = 'balance-coupon' //余额卡券支付
                  that.request('YeunifiedOrder', order_param)
                })
                .catch(() => {
                  return false;
                });
            }
          }else{
            if (parseFloat(that.amount) < parseFloat(this.showItem.price)) {
              Dialog.confirm({
                  title: '提示',
                  message: '积分不足，前往充值？',
                })
                .then(() => {
                  that.$router.push({
                    path: "/account"
                  })
                })
                .catch(() => {
                  return false;
                });
            } else {
              Dialog.confirm({
                  title: '提示',
                  message: '是否用余额支付?',
                })
                .then(() => {
                  order_param.pay_type = 'balance' //余额卡券支付
                  that.request('YeunifiedOrder', order_param)
                })
                .catch(() => {
                  return false;
                });
            }
          }

        // }

      },

      // 调用接口
      request(type = "", requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                console.log("用户信息", res.data)
                that.userInfo = res.data
                that.mobile = res.data.mobile

                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
              }
            }, true)
            break
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              if (res.code === 0) {
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //卡券列表
          case "getCouponList":
            httper.post("coupon/package-list", requestData, res => {
              let list = [];
              if (res.data) {
                console.log("res.data", res.data)
                res.data.map(function(item, i) {
                  if (item.product.type == that.showItem.product.type && item.product.type == 2 && item.status ==
                    0 && item.type == 3) {
                    list.push(item)
                  } else if (item.product_id == that.showItem.product_id && item.status == 0 && item.type == 3) {
                    list.push(item)
                  }
                })

                if (list.length > 0) {
                  list.map(v => {
                    that.$set(v, 'checked', false)
                    return v
                  })
                  list[0].checked = true
                  that.settlementItem.selectedID = list[0].id
                  that.preferentialAmount = list[0].amount
                  //卡券金额
                  let originalPrice = parseFloat(that.preferentialAmount)
                  //商品价格
                  let price = parseFloat(that.showItem.price)
                  //实付金额
                  that.payAmount = price > originalPrice ? (price - originalPrice).toFixed(2) : 0
                  // that.couponId = list[0].id
                } else {
                  // that.preferentialAmount = "无"
                  that.payAmount = parseFloat(that.showItem.price)
                }
                that.settlementItem.couponList = list;
                console.log("couponList", that.settlementItem.couponList)

              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true);

            break;
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: 'orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style scoped>
  .buy {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .buy_top {
    margin: 10px 0;
    width: 90%;
    height: 134px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .buy_img {
    width: 35px;
    height: 35px;
    margin-bottom: 10px;
  }

  .buy_name {
    font-size: 19px;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }

  .buy_shangpin_title {
    display: flex;
    align-items: center;
  }

  .buy_shangpin_title_icon {
    width: 3px;
    height: 23px;
    margin-right: 10px;
  }

  .buy_shangpin_title_name {
    font-size: 15px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
  }

  .buy_shangpinmesg {
    width: 90%;
    height: 190px;
    padding: 10px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
  }

  .buy_shangpinmesg1 {
    width: 90%;
    height: 130px;
    padding: 10px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
    margin-top: 10px;
  }

  .buy_shangpin_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }

  .buy_shangpin_mesgname {
    font-size: 11px;
    font-weight: 400;
    color: rgba(101, 101, 101, 1);
  }

  .buy_shangpin_mesgname1 {
    font-size: 15px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
    display: flex;
    align-items: center;
  }

  .buy_shangpin_mesglogo {
    width: 17px;
    height: 17px;
    margin-right: 10px;
  }

  .buy_shangpin_shoujia {
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
  }

  .buy_button {
    margin-top: 20px;
  }

  .buy_shangpin_usejifen {
    display: flex;
    align-items: center;
  }

  .buy_shangpin_keyong {
    font-size: 12px;
    color: #666666;
    margin-right: 10px;
  }

  .checklogo {
    width: 15px;
    height: 15px;
    margin-left: 10px;
  }


  .popup_top {
    display: flex;
    height: 30px;
    padding: 16px;
    border-bottom: 1px solid #d6d6d6;
    align-items: center;
    font-size: 18px;
  }

  .guanbi {
    width: 20px;
    height: 20px;
    margin-right: 130px;
  }

  .couponCell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .reserceDesc_section {
    padding: 10px;
  }

  .reserceDesc_check {
    width: 15px;
    height: 15px;
  }

  /* 服务券 */
  .reserceDesc_fuwuprice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*    margin-bottom: 20px; */
    margin-top: 14px;
  }


  .reserceDesc_fuwupricename {}


  .reserceDesc_jiesuancheck {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .reserceDesc_jiesuanpricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
    margin-right: 10px;
  }

  /*  .couponBox-box{
    width: calc(100% - 20px);
    margin: 10px;
  } */
  .couponBox {
    width: calc(100% - 20px);
    margin: 10px;
    position: relative;
    border-radius: 8px;
    border: 1px solid #EEEEEE;
    padding: 13px;
    box-sizing: border-box;
  }

  .couponBox-select {
    width: calc(100% - 20px);
    margin: 10px;
    position: relative;
    border-radius: 8px;
    border: 1px solid #E60012;
    padding: 13px;
    box-sizing: border-box;
  }

  .couponBox1 {
    width: calc(100% - 20px);
    margin: 10px;
    position: relative;
    border-radius: 8px;
    background-color: #EEEEEE;
    padding: 13px;
    box-sizing: border-box;
  }

  .canUseimg {
    width: 69px;
    height: 23px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .coupon-name {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .coupon-time {
    font-size: 14px;
    color: #BBBBBB;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/buy.vue